import React from 'react';
import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuthContext } from '../../auth/useAuthContext';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isInitialized } = useAuthContext();
  const { t } = useTranslation();

  // Show loading while checking authentication
  if (!isInitialized) {
    return <div>{t('common.loading')}</div>;
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Render children if authenticated
  return children;
};

export default ProtectedRoute;
